<template>
  <div>
    <el-dialog
      :visible.sync="innerVisible"
      :title="title"
      width="700px"
      :close-on-click-modal="false"
    >
      <el-form class="spacing">
        <el-form-item>
          <span slot="label">
            <div class="frm" />
          </span>
          {{ $t('SeaExport.BasicInfo') }}
        </el-form-item>
      </el-form>
      <el-form label-width="120px" label-position="right" :disabled="look">
        <el-row>
          <el-col :span="12">
            <el-form-item>
              <span slot="label" class="blue">{{ $t('FbaChannel.channelName') }}</span>
              <el-input v-model="form.channelName" :no="'channelName'" style="width: 120px" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item>
              <span slot="label" class="blue">{{ $t('FbaChannel.shippingType') }}</span>
              <cargo-advance-select
                no="shippingType"
                :select-type="selectTypeNames.local_cache_FbaJobConstants$SHIPPING_TYPES"
                filterable
                style="width: 120px"
                :clearable="true"
                :default-value="form.shippingType"
                @parentCallBack="shippingTypeChange"
              />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <el-form label-width="120px" label-position="right" :disabled="look">
        <el-row>
          <el-col :span="12">
            <el-form-item>
              <span slot="label" class="blue">{{ $t('FbaChannel.destinationDistribution') }}</span>
              <cargo-advance-select
                no="destinationDistribution"
                :select-type="selectTypeNames.local_cache_FbaJobConstants$ORDER_DESTINATION_DISTRIBUTION_TYPES"
                filterable
                style="width: 120px"
                :clearable="true"
                :default-value="form.destinationDistribution + ''"
                @parentCallBack="p=>{form.destinationDistribution=Number(p.value)}"
              />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <el-form class="spacing">
        <el-form-item>
          <span slot="label">
            <div class="frm" />
          </span>
          {{ $t('FbaChannel.weightInfo') }}
        </el-form-item>
      </el-form>
      <el-form label-width="120px" label-position="right" :disabled="look">
        <el-row>
          <el-col :span="12">
            <el-form-item>
              <span slot="label" class="blue">{{ $t('FbaChannel.chargingMethod') }}</span>
              <el-radio-group v-model="form.chargingMethod">
                <el-radio :label="0">{{ 'KG' }}</el-radio>
                <el-radio :label="1">{{ 'CBM' }}</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item>
              <span slot="label" class="blue">{{ $t('FbaChannel.bubbleCountingRatio') }}</span>
              <el-input-number v-model="form.bubbleCountingRatio" :no="'bubbleCountingRatio'" style="width: 120px;" controls-position="right" :max="9999" :min="1" :precision="0" />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <el-form label-width="120px" label-position="right" :disabled="look">
        <el-row>
          <el-col :span="12">
            <el-form-item>
              <span slot="label" class="blue">{{ $t('FbaChannel.singleBoxLowestBillableWeight') }}</span>
              <el-input-number v-model="form.singleBoxLowestBillableWeight" :no="'singleBoxLowestBillableWeight'" style="width: 120px;" controls-position="right" :max="999.99" :min="0" :precision="2" /> {{ 'KG' }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item>
              <span slot="label" class="blue" style="margin-right: 4px">{{ $t('FbaChannel.multipleBoxesCalculationRules') }}</span>
              <el-popover
                slot="label"
                placement="bottom"
                trigger="hover"
              >
                <div class="pop-content">{{ '什么是多箱计算规则？' }}</div>
                <div class="pop-content">{{ '多箱计算规则是用于在一单多箱的情况下，根据每箱货的重量、体积计算整个订单的结算重，目前包括两种可选规则：先累加再比较、先比较再累加；' }}</div>
                <div class="pop-content">{{ '先累加再比较：先将单箱的重量做累加、将单箱的体积做累加，再根据重量体积转换系数转换后取较大值，得到最终的结算重；' }}</div>
                <div class="pop-content">{{ '先比较再累加：分别对每一箱的重量和体积，根据重量体积转换系数转换后取较大值，之后累加得到结算重；' }}</div>
                <svg-icon slot="reference" icon-class="question" style="font-size: 14px;margin-right: 0;" />
              </el-popover>
              <cargo-advance-select
                no="multipleBoxesCalculationRules"
                :select-type="selectTypeNames.local_cache_FbaJobConstants$MULTIPLE_BOXES_CALCULATION_RULES"
                filterable
                style="width: 120px"
                :clearable="false"
                :default-value="form.multipleBoxesCalculationRules"
                @parentCallBack="p=>{form.multipleBoxesCalculationRules=p.value}"
              />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <el-form label-width="120px" label-position="right" :disabled="look">
        <el-row>
          <el-col :span="12">
            <el-form-item>
              <span slot="label" class="blue">{{ $t('FbaChannel.settlementWeightRoundingRules') }}</span>
              <cargo-advance-select
                no="settlementWeightRoundingRules"
                :select-type="selectTypeNames.local_cache_FbaJobConstants$SETTLEMENT_WEIGHT_ROUNDING_RULES"
                filterable
                style="width: 120px"
                :clearable="true"
                :default-value="form.settlementWeightRoundingRules"
                @parentCallBack="p=>{form.settlementWeightRoundingRules=p.value}"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item>
              <span slot="label" class="blue">{{ $t('FbaChannel.BubbleSplittingRatio') }}</span>
              <el-input-number v-model="form.bubbleSplittingRatio" :no="'bubbleSplittingRatio'" style="width: 120px;" controls-position="right" :max="100" :min="0" :precision="0" /> {{ '%' }}
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <el-form class="spacing">
        <el-form-item>
          <span slot="label">
            <div class="frm" />
          </span>
          {{ $t('FbaChannel.acceptableGoods') }}
        </el-form-item>
        <el-form class="spacing" :disabled="look">
          <el-form-item>
            <el-checkbox-group v-model="acceptableGoods" style="margin-left: 20px" @change="acceptableGoodsChangeHandler">
              <el-checkbox
                v-for="item in fbaCargoType"
                :key="item.code"
                :label="item.code"
              >
                {{ item.chineseName }}
              </el-checkbox>
            </el-checkbox-group>
          </el-form-item>
        </el-form>
      </el-form>
      <span slot="footer">
        <el-button :disabled="look" type="primary" :no="'save'" @click="save">{{ $t('common.btn.save') }}</el-button>
        <el-button :no="'cancel'" @click="innerVisible=false">{{ $t('common.btn.cancel') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>

import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { getSpecificBasicDataFromCache } from '@/utils/basicDataCache'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import { getUserInfo } from '@/utils/auth'
import { getUsedFbaChannel, saveFbaChannel } from '@/api/Fba/fbaChannel'
import { getLoading } from '@/utils/utilBaseElement'

export default {
  name: 'FbaChannelEditDialog',
  components: {
    cargoAdvanceSelect
  },
  props: {
    visible: { type: Boolean, required: true },
    look: { type: Boolean, required: true },
    title: { type: String, required: true },
    fbaChannel: { type: Object, default: null }
  },
  data() {
    return {
      innerVisible: false,
      selectTypeNames: TYPE_NAMES,
      acceptableGoods: [],
      fbaCargoType: [],
      tenantId: 0,
      initChannelName: '',
      baseForm: {
        uuid: '',
        channelName: '',
        shippingType: '',
        destinationDistribution: '',
        chargingMethod: 0,
        bubbleCountingRatio: 6000.0,
        bubbleSplittingRatio: 0.0,
        singleBoxLowestBillableWeight: 0.0,
        multipleBoxesCalculationRules: 0,
        settlementWeightRoundingRules: 0,
        acceptableGoods: ''
      },
      form: {
        uuid: '',
        channelName: '',
        shippingType: '',
        destinationDistribution: '',
        chargingMethod: 0,
        bubbleCountingRatio: 6000.0,
        bubbleSplittingRatio: 0.0,
        singleBoxLowestBillableWeight: 0.0,
        multipleBoxesCalculationRules: 0,
        settlementWeightRoundingRules: 0,
        acceptableGoods: ''
      }
    }
  },
  watch: {
    visible(newVal) {
      this.innerVisible = newVal
      if (newVal) {
        this.init()
      }
    },
    innerVisible(newVal) {
      this.$emit('update:visible', newVal)
    }
  },
  created() {
    if (this.visible) {
      this.innerVisible = true
      this.init()
    }
  },
  methods: {
    init() {
      const user = getUserInfo()
      this.tenantId = user.tenantId
      if (!this.fbaChannel) {
        Object.assign(this.form, this.baseForm)
        this.acceptableGoods = []
        this.initChannelName = ''
      } else {
        Object.assign(this.form, this.fbaChannel)
        this.initChannelName = this.fbaChannel.channelName
      }
      // 获取货物类型
      this.fbaCargoType = []
      const res = getSpecificBasicDataFromCache(this.selectTypeNames.basic_data_CargoType)
      for (const item of res) {
        switch (this.form.shippingType) {
          case 'SE':
            if (item.fbaSea) {
              this.fbaCargoType.push(item)
            }
            break
          case 'AE':
            if (item.fbaAir) {
              this.fbaCargoType.push(item)
            }
            break
          case 'RE':
            if (item.fbaRailway) {
              this.fbaCargoType.push(item)
            }
            break
          default:
            if (item.fbaSea || item.fbaAir || item.fbaRailway) {
              this.fbaCargoType.push(item)
            }
        }
      }
      // 转换货物类型
      if (this.form.acceptableGoods && this.form.acceptableGoods.split(',').length > 0) {
        this.acceptableGoods = this.form.acceptableGoods.split(',')
      }
    },
    acceptableGoodsChangeHandler() {
      this.form.acceptableGoods = this.acceptableGoods.join(',')
    },
    shippingTypeChange(data) {
      this.form.shippingType = data.value
      if (data.value === 'AE') {
        this.form.chargingMethod = 0
      }
      if (data.value === 'SE' || data.value === 'RE') {
        this.form.chargingMethod = 1
      }
      this.fbaCargoType = []
      this.acceptableGoods = []
      const res = getSpecificBasicDataFromCache(this.selectTypeNames.basic_data_CargoType)
      for (const item of res) {
        switch (data.value) {
          case 'SE':
            if (item.fbaSea) {
              this.fbaCargoType.push(item)
            }
            break
          case 'AE':
            if (item.fbaAir) {
              this.fbaCargoType.push(item)
            }
            break
          case 'RE':
            if (item.fbaRailway) {
              this.fbaCargoType.push(item)
            }
            break
          default:
            if (item.fbaSea || item.fbaAir || item.fbaRailway) {
              this.fbaCargoType.push(item)
            }
        }
      }
    },
    async save() {
      if (!this.checkSave()) {
        return
      }
      const data = { channelNameList: [this.initChannelName], tenantId: this.tenantId }
      let usedFlag = false
      let loading = getLoading()
      await getUsedFbaChannel(data).then(res => {
        const data = res.data
        if (data && data.length > 0) {
          usedFlag = true
        }
      }).finally(() => loading.close())
      let syncQuotation = false
      if (usedFlag) {
        if (this.initChannelName !== this.form.channelName) {
          this.$message.warning(this.$t('FbaChannel.notEditName'))
          this.form.channelName = this.initChannelName
          return
        }
        await this.$confirm(this.$t('FbaChannel.editExistChannel'), this.$t('Message.Tips'), {
          confirmButtonText: this.$t('CargoMsg.Cargo_Yes'),
          cancelButtonText: this.$t('CargoMsg.Cargo_No'),
          type: 'warning'
        }).then(() => {
          syncQuotation = true
        }).catch(() => {
          syncQuotation = false
        })
      }
      this.form.tenantId = this.tenantId
      this.form.syncQuotation = syncQuotation
      this.form.oldChannelName = this.initChannelName
      loading = getLoading()
      saveFbaChannel(this.form).then(resp => {
        this.$emit('saveCallBack', resp.data)
        this.$message.success(this.$t('common.tips.saveSuccess'))
        this.$emit('close')
      }).finally(() => loading.close())
    },
    checkSave() {
      if (!this.form.channelName) {
        this.$message.warning(this.$t('FbaChannel.channelNameNoEmpty'))
        return false
      }
      if (!this.form.shippingType) {
        this.$message.warning(this.$t('FbaChannel.shippingTypeNoEmpty'))
        return false
      }
      if (typeof this.form.destinationDistribution !== 'number') {
        this.$message.warning(this.$t('FbaChannel.destinationDistributionNoEmpty'))
        return false
      }
      if (typeof this.form.chargingMethod !== 'number') {
        this.$message.warning(this.$t('FbaChannel.chargingMethodNoEmpty'))
        return false
      }
      if (typeof this.form.bubbleCountingRatio !== 'number') {
        this.$message.warning(this.$t('FbaChannel.bubbleCountingRatioNoEmpty'))
        return false
      }
      if (typeof this.form.bubbleSplittingRatio !== 'number') {
        this.$message.warning(this.$t('FbaChannel.bubbleSplittingRatioNoEmpty'))
        return false
      }
      if (typeof this.form.singleBoxLowestBillableWeight !== 'number') {
        this.$message.warning(this.$t('FbaChannel.singleBoxLowestBillableWeightNoEmpty'))
        return false
      }
      if (typeof this.form.multipleBoxesCalculationRules !== 'number') {
        this.$message.warning(this.$t('FbaChannel.multipleBoxesCalculationRulesNoEmpty'))
        return false
      }
      if (typeof this.form.settlementWeightRoundingRules !== 'number') {
        this.$message.warning(this.$t('FbaChannel.settlementWeightRoundingRulesNoEmpty'))
        return false
      }
      if (!this.acceptableGoods || this.acceptableGoods.length === 0) {
        this.$message.warning(this.$t('FbaChannel.acceptableGoodsNoEmpty'))
        return false
      }
      return true
    }
  }
}
</script>
<style lang="scss">
.frm{
  display: flex;
  width: 10px;
  height: 28px;
  background: dodgerblue;
}
</style>
